<template>
  <ul id="bg-comments" class="bg-comments" v-if="getContentDetailsPublicData.comments && getContentDetailsPublicData.comments.length > 0">
    <li
      v-for="(comment, index) in getContentDetailsPublicData.comments.slice(
        0,
        showAllVar
      )"
      :key="index"
    >
      <div class="authorsbox">
        <figure class="authorimg">
          <img
            v-if="comment.author.profile_image != null"
            :src="`${getBlogUrl}/${comment.author.profile_image}`"
          />
          <img
            v-if="comment.author.profile_image == null"
            src="../../assets/images/imag-27.jpg"
          />
        </figure>
        <div class="authorsinfo">
          <div class="authorshead">
            <div class="leftarea">
              <div class="authorsname">
                <h2>{{ comment.author.name }}</h2>
                <span>Date: {{ comment.created_at.slice(0, 10) }}</span>
              </div>
            </div>
            <div class="rightarea">
              <a v-if="loggedInData.user"
                class="allbutton-btnreply"
                @click="showCommentReply({ id: comment.id, act: 'Reply' })"
                >Reply
                <i class="fas fa-reply"></i>
              </a>
              <a
                v-if=" loggedInData.user && comment.author &&
                  loggedInData.token != 'null' &&
                  loggedInData.user.id == comment.author.id
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <i
                      v-on="on"
                      v-bind="attrs"
                      class="fa fa-edit allbutton-btnreply"
                      @click="
                        showCommentReply({
                          id: comment.id,
                          act: 'Edit',
                          commentBody: comment.body,
                        })
                      "
                    ></i>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
        
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <i
                      v-on="on"
                      v-bind="attrs"
                      class="fa fa-trash allbutton-btnreply"
                      @click="
                        deleteConfirm({ id: comment.id, type: 'comment' })
                      "
                    ></i>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </a>
            </div>
          </div>
          <div class="description">
            <p>{{ comment.body }}</p>
          </div>
          <div
            v-show="
              comment.id == showReply.value &&
              showReply.state &&
              loggedInData.token != 'null'
            "
          >
            <v-text-field
              v-show="showReply.act == 'Reply'"
              v-model="commentReply.body"
              label="Add your reply"
            ></v-text-field>
            <v-text-field
              v-show="showReply.act == 'Edit'"
              v-model="blogComment.body"
              label="Edit your comment"
            ></v-text-field>
            <div class="float-right m-3">
              <button
                type="button"
                class="btn btn-light"
                @click="clearCommentReply"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="actionContentCommentReply()"
              >
                {{ showReply.act }}
              </button>
            </div>
          </div>
          <div
            v-show="
              comment.id == showReply.value &&
              showReply.state &&
              loggedInData.token == 'null'
            "
            style="color: crimson"
          >
            You need to use a logged in account
          </div>
        </div>
        <div class="bottomarrow"></div>
      </div>
      <ul class="childcomment forReply">
        <li v-for="(reply, index) in comment.replies" :key="index">
          <div class="authorsbox">
            <figure class="authorimg">
              <img
                v-if="reply.author.profile_image != null"
                :src="`${getBlogUrl}/${reply.author.profile_image}`"
                alt="image description"
              />
              <img
                v-if="reply.author.profile_image == null"
                src="../../assets/images/imag-27.jpg"
                alt="image description"
              />
            </figure>
            <div class="authorsinfo">
              <div class="authorshead">
                <div class="leftarea">
                  <div class="authorsname">
                    <h2>{{ reply.author.name }}</h2>
                    <span>Date: {{ reply.created_at.slice(0, 10) }}</span>
                  </div>
                </div>
                <div class="rightarea">
                  <a v-if="loggedInData.user"
                    class="allbutton-btnreply"
                    @click="
                      controlReplyReply({
                        id: comment.id,
                        act: 'Reply',
                        controlId: reply.id,
                      })
                    "
                    >Reply
                    <i class="fas fa-reply"></i>
                  </a>
                  <a
                    v-if="loggedInData.user && reply.author &&
                      loggedInData.token != 'null' &&
                      loggedInData.user.id == reply.author.id
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i
                          v-on="on"
                          v-bind="attrs"
                          class="fa fa-edit allbutton-btnreply"
                          @click="
                            controlReplyReply({
                              id: comment.id,
                              act: 'Edit',
                              replyBody: reply.body,
                              controlId: reply.id,
                            })
                          "
                        ></i>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i
                          v-on="on"
                          v-bind="attrs"
                          class="fa fa-trash allbutton-btnreply"
                          @click="
                            deleteConfirm({ id: reply.id, type: 'reply' })
                          "
                        ></i>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>

                   
                  </a>
                </div>
              </div>
              <div class="description">
                <p>{{ reply.body }}</p>
              </div>
              <div
                v-if="
                  showReplyReply.state &&
                  showReplyReply.value == reply.id &&
                  loggedInData.token != 'null'
                "
              >
                <v-text-field
                  v-model="commentReply.body"
                  label="Reply field"
                ></v-text-field>
                <div class="float-right m-3">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="clearCommentReply"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="actionCommentReply(reply.id)"
                  >
                    {{ showReplyReply.act }}
                  </button>
                </div>
              </div>
              <div
                v-if="
                  showReplyReply.state &&
                  showReplyReply.value == reply.id &&
                  loggedInData.token == 'null'
                "
                style="color: crimson"
              >
                You need to use a logged in account
              </div>
            </div>
            <div class="bottomarrow"></div>
          </div>
        </li>
      </ul>
    </li>
    <li
      v-show="
        showAllVar == getContentDetailsPublicData.comments_count ? false : true
      "
      class="bg-loadmore"
    >
      <a
        class="allbutton-btn bg-active"
        href="javascript:void(0);"
        @click="changeShowAll"
      >
        View All
      </a>
    </li>
    <v-snackbar v-model="deleteAlert" centered>
      Do you want to proceed?
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="cancelDeleteCommentReply()"
        >
          Cancel
        </v-btn>
        <v-btn color="green" text v-bind="attrs" @click="deleteCommentReply()">
          Confirm
        </v-btn>
      </template>
    </v-snackbar>
  </ul>
</template>

<script>
import { baseURL2 } from "@/store/api.js";
export default {
  name: "commentReply",
  props: ["loggedInData", "getContentDetailsPublic"],
  data() {
    return {
      blogComment: {
        blog_id: null,
        body: "",
      },
      commentReply: {
        comment_id: null,
        body: "",
      },
      showAllVar: 3,
      showReply: {
        value: null,
        state: false,
        act: null,
      },
      showReplyReply: {
        value: null,
        state: false,
        act: null,
      },
      deleteAlert: false,
      deleteControl: {
        id: null,
        type: null,
      },
    };
  },
  created() {},
  computed: {
    getContentDetailsPublicData() {
      let tempData = this.getContentDetailsPublic;
      this.blogComment.blog_id = tempData.id;
      return tempData;
    },

    getBlogUrl() {
      // return `${baseURL2}/${this.getContentDetailsPublicData.content_url}`;
      return baseURL2;
    },
  },
  methods: {
    showCommentReply(data) {
      this.showReply.value = data.id;
      this.showReply.state = true;
      this.showReply.act = data.act;
      if (data.act == "Edit") {
        this.blogComment.body = data.commentBody;
      }
    },
    actionContentCommentReply() {
     //  console.log("anoy");
      if (this.showReply.act == "Reply") {
        this.commentReply.comment_id = this.showReply.value;
        this.postCommentReply();
      } else if (this.showReply.act == "Edit") {
        let tempData = {
          id: this.showReply.value,
          body: this.blogComment,
        };
       //  console.log("anoy", tempData);
        this.editContentComment(tempData);
      }
    },
    changeShowAll() {
      this.showAllVar = this.getContentDetailsPublicData.comments_count;
    },
    controlReplyReply(data) {
      if (data.act == "Edit") {
        this.commentReply.body = data.replyBody;
      }
      this.commentReply.comment_id = data.id;
      this.showReplyReply.value = data.controlId;
      this.showReplyReply.state = true;
      this.showReplyReply.act = data.act;
    },
    actionCommentReply(data) {
      if (this.showReplyReply.act == "Reply") {
        this.postCommentReply();
      } else if (this.showReplyReply.act == "Edit") {
        let tempData = {
          id: data,
          body: this.commentReply,
        };
        this.editCommentReply(tempData);
      }
    },
    async postCommentReply() {
      await this.$store
        .dispatch("addPortalReply", this.commentReply)
        .then((response) => {
          if (response) {
          }
        })
        .catch((error) => {
          return error;
        });
      this.clearCommentReply();
      this.$emit("reloadContent");
    },
    async editContentComment(data) {
      await this.$store
        .dispatch("editPortalComment", data)
        .then((response) => {})
        .catch((error) => {});
      this.clearCommentReply();
      this.$emit("reloadContent");
    },
    async editCommentReply(data) {
      await this.$store
        .dispatch("editPortalReply", data)
        .then((response) => {})
        .catch((error) => {});
      this.clearCommentReply();
      this.$emit("reloadContent");
    },
    async deleteComment(data) {
      await this.$store
        .dispatch("deletePortalComment", data)
        .then((response) => {})
        .catch((error) => {});
      this.$emit("reloadContent");
    },
    async deleteReply(data) {
      await this.$store
        .dispatch("deletePortalReply", data)
        .then((response) => {})
        .catch((error) => {});
      this.$emit("reloadContent");
    },
    clearCommentReply() {
      this.commentReply.body = "";
      this.blogComment.body = "";
      this.showReply.value = null;
      this.showReply.state = false;
      this.showReply.act = null;
      this.showReplyReply.value = null;
      this.showReplyReply.state = false;
      this.showReplyReply.act = null;
    },
    deleteConfirm({ id, type }) {
      this.deleteControl.id = id;
      this.deleteControl.type = type;
      this.deleteAlert = true;
    },
    deleteCommentReply() {
      if (this.deleteControl.type == "comment") {
        this.deleteComment(this.deleteControl.id);
      } else if (this.deleteControl.type == "reply") {
        this.deleteReply(this.deleteControl.id);
      }
      this.deleteAlert = false;
    },
    cancelDeleteCommentReply() {
      this.deleteControl.id = null;
      this.deleteControl.type = null;
      this.deleteAlert = false;
    },
  },
};
</script>

<style scoped>
.row {
  display: block;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
.forReply {
  width: 90%;
  float: right;
}
</style>
